const readMoreTarget = '.wm-readMore__Button';
const readLessTarget = '.wm-readLess__Button';
jQuery(document).on('ready', function () {
    jQuery(readMoreTarget).click(function () {
        console.log("clicked");
        jQuery(this).next('.wm-readMore__Section').slideToggle();
        jQuery(this).slideToggle();
    });
    jQuery(readLessTarget).click(function () {
        jQuery(this).parent('.wm-readMore__Section').slideToggle();
        jQuery(this).parent().siblings(readMoreTarget).slideToggle();
    });
});
